import { Divider, Drawer, Grid, IconButton, List } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { inject } from 'mobx-react';
import * as React from 'react';
import { IUser } from 'src/Definitions';
import ProfileListItem from '../../common/ProfileListItem';
import * as Logo from '../../images/logo.png';
import * as SmallLogo from '../../images/small_logo.png';
import { INavigationSection } from '../../Routes';
import { IStores } from '../../Stores';
import NavigationSection from '../NavigationSection/NavigationSection';

const styles = ({ spacing }: Theme) => {
    const drawerClosedWidth = spacing.unit * 9;
    const drawerExpandedWidth = spacing.unit * 28;
    const expandButtonMarginLeftModifier = spacing.unit * 1.5;
    return createStyles({
        drawerClosed: {
            backgroundColor: '#dc220d',
            color: 'white',
            width: drawerClosedWidth,
        },
        drawerExpanded: {
            backgroundColor: '#dc220d',
            color: 'white',
            width: drawerExpandedWidth,
        },
        drawerGrid: {
            height: '100%',
        },
        expandButton: {
            position: 'fixed',
            top: '50%',
        },
        expandButtonDrawerClosed: {
            marginLeft: drawerClosedWidth - expandButtonMarginLeftModifier,
        },
        expandButtonDrawerExpanded: {
            marginLeft: drawerExpandedWidth - expandButtonMarginLeftModifier,
        },
        imageContainer: {
            backgroundColor: 'white',
            height: spacing.unit * 9,
        },
        imageContainerOpen: {
            backgroundColor: 'white',
            'padding-bottom': 10,
            'padding-top': 10,
        },
    });
};

interface INavigationDrawerProps extends WithStyles<typeof styles> {
    logout?: () => void;
    navigationSections: INavigationSection[];
    isOpen: boolean;
    toggleDrawer: () => void;
    user?: IUser;
}

class NavigationDrawer extends React.Component<INavigationDrawerProps> {
    public render() {
        const { classes, logout, isOpen } = this.props;
        const drawerClassName = this.getDrawerClassName();
        const expandButtonClassName = this.getExpandButtonClassName();
        return (
            <div>
                <Drawer variant="permanent" open={isOpen}>
                    <Grid
                        container
                        direction="column"
                        justify="space-between"
                        alignItems="stretch"
                        className={drawerClassName}
                    >
                        <Grid item>
                            <Grid
                                className={
                                    isOpen ? classes.imageContainerOpen : classes.imageContainer
                                }
                                container
                                direction="row"
                                alignItems="center"
                                item
                                justify="center"
                            >
                                {this.props.isOpen ? (
                                    <img src={Logo} alt="Logo" width="90%" />
                                ) : (
                                    <img src={SmallLogo} alt="Logo" width="90%" />
                                )}
                            </Grid>
                            <Divider />
                            <List>{this.renderNavigationSections()}</List>
                        </Grid>
                        <Grid item>
                            <Divider />
                            <List>
                                <ProfileListItem expanded={isOpen} logout={logout!} />
                            </List>
                        </Grid>
                    </Grid>
                </Drawer>
                <div className={expandButtonClassName}>
                    <IconButton onClick={this.props.toggleDrawer}>
                        {isOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
            </div>
        );
    }

    private renderNavigationSections(): JSX.Element[] {
        const { navigationSections, isOpen, user } = this.props;

        return navigationSections.reduce<JSX.Element[]>((sections, section, index) => {
            const sectionElement = (
                <NavigationSection
                    key={'section-' + index}
                    isOpen={isOpen}
                    navigationSection={section}
                    user={user!}
                    headerTextColor={'white'}
                />
            );
            if (sections.length > 0) {
                sections.push(<Divider key={'divider-' + index} />);
            }
            sections.push(sectionElement);
            return sections;
        }, []);
    }

    private getDrawerClassName(): string {
        const { classes, isOpen } = this.props;
        const classesToApply = [classes.drawerGrid];
        classesToApply.push(isOpen ? classes.drawerExpanded : classes.drawerClosed);
        return classesToApply.join(' ');
    }

    private getExpandButtonClassName(): string {
        const { classes, isOpen } = this.props;
        const classesToApply = [classes.expandButton];
        classesToApply.push(
            isOpen ? classes.expandButtonDrawerExpanded : classes.expandButtonDrawerClosed
        );
        return classesToApply.join(' ');
    }
}

export default inject<IStores, INavigationDrawerProps, Partial<INavigationDrawerProps>, any>(
    (stores: IStores) => ({
        logout: () => stores.login.logout(),
        user: stores.global.user,
    })
)(withStyles(styles)(NavigationDrawer));



// WEBPACK FOOTER //
// ./src/core/NavigationDrawer/NavigationDrawer.tsx